<template>
  <div class="montant" :class="{ detail: detail, 'is-annotation': montant.plafond }">
    <div v-if="isFourchette" class="value-wrapper">
      <div>
        <p>
          <span class="detail-fourchette">entre</span> <span class="value">{{ formattedMontant }}</span>
        </p>
        <p>
          <span class="detail-fourchette">et</span> <span class="value">{{ formattedMontantMax }}</span>
        </p>
      </div>
      <p v-if="isPourcentage && detail" class="detail-montant">du montant des travaux</p>
    </div>
    <div v-else>
      <p>
        <span class="value">{{ formattedMontant }}</span>
        <span v-if="isPourcentage && detail" class="detail-montant">du montant des travaux</span>
        <span v-if="montant.type === 'UNITAIRE'">
           / {{ montant.unite }}
        </span>
      </p>
    </div>
    <div v-if="montant.poste" class="montant-tag">
      {{ montant.poste }}
    </div>
    <div class="annotation" v-if="montant.plafond && detail">
      jusqu'à {{ montant.plafond.valeur }} {{ montant.plafond.type }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MontantAide',
  props: {
    montant: {
      type: Object,
      required: true
    },
    detail: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      typesMontant: {
        FORFAITAIRE: '€',
        POURCENTAGE: '%',
        FOURCHETTE: '€',
        FOURCHETTE_POURCENTAGE: '%',
        UNITAIRE: '€'
      }
    }
  },
  computed: {
    isFourchette () {
      return this.montant.type === 'FOURCHETTE' ||
        this.montant.type === 'FOURCHETTE_POURCENTAGE'
    },
    isPourcentage () {
      return this.montant.type === 'POURCENTAGE' ||
        this.montant.type === 'FOURCHETTE_POURCENTAGE'
    },
    formattedMontant () {
      return this.montant.valeur + ' ' + this.typesMontant[this.montant.type]
    },
    formattedMontantMax () {
      return this.montant.valeur_max + ' ' + this.typesMontant[this.montant.type]
    }
  }
}
</script>

<style lang="scss">
.montant {
  position: relative;
  font-size: $text-size;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  font-family: $primary-font;
  .value {
    font-weight: 700;
    font-size: 2rem;
  }
  .detail-montant {
    font-weight: 700;
    margin-left: 10px;
    font-size: 1.4rem;
  }
  .montant-tag {
    margin-top: 6px;
    min-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: $radius-sm;
    color: #fff;
    background-image: $primary-gradient;
    font-size: $text-size-sm;
    font-family: $secondary-font;
    padding: 0 10px;
    min-width: 100px;
  }
  &.detail {
    border: 2px solid $secondary-color;
    border-radius: $radius;
    padding: 20px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 520px;
    .value-wrapper {
      > div {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
      }
      p {
        .detail-fourchette {
          font-size: 1.4rem;
          margin-right: 0.5rem;
        }
        &:first-child {
          margin-right: 10px;
        }
      }
    }
    .montant-tag {
      margin-top: 5px;
      height: auto;
      color: $primary-color;
      font-size: $text-size;
      background-image: none;
      min-width: auto;
      padding: 0;
    }
    &.is-annotation {
      padding-bottom: 60px;
    }
    .annotation {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      padding: 10px 0;
      text-align: center;
      background-color: $secondary-color;
      color: #fff;
      font-family: $secondary-font;
      font-size: $text-size;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
}
</style>
